export default {
    Menu: 'Menu',
    Add: 'Ajouter',
    Modify: 'Modifier',
    Delete: 'Supprimer',
    Scale: 'Redimensionner',
    Color: 'Couleur',
    Materials: 'Matériaux',
    Mesh: 'Maillage',
    Size: 'Taille',
    Details: 'Détails',
    Quantity: 'Quantité',
    EnterYourQuantity: 'Saisir ma quantité',
    ChooseQuantity: 'Choisir la quantité',
    Pieces: 'pièces',
    Piece: 'pièce',
    SavePercent: 'Économisez {pct}%',
    AddToCart: 'Ajouter au panier',
    AddToCartTitle: 'Mettre au panier',
    Cart: 'Panier',
    Total: 'Total',
    Subtotal: 'Sous-total',
    Shipping: 'Livraison',
    Shape: 'Forme',
    PickShape: 'Choisissez une forme à ajouter au canvas',
    ShapeAdded: 'Forme ajoutée. Cliquez sur une autre pour la remplacer.',
    Clipart: 'Illustration',
    PickClipart: 'Choisissez une illustration à ajouter au canvas',
    ClipartAdded: 'Illustration ajoutée. Cliquez sur une autre pour la remplacer.',
    SearchClipart: 'Rechercher une illustration…',
    NoClipartFound: 'Aucune illustration trouvée',
    Cliparts: 'Cliparts',
    Illustration: 'Illustration',
    AiImage: 'Image IA',
    AiImageIntro: 'Décrivez ce que vous voulez, choisissez un format, et obtenez 2 propositions.',
    AiImageFormat: 'Format',
    AiFormatSquare: 'Carré',
    AiFormatPortrait: 'Portrait',
    AiFormatLandscape: 'Paysage',
    AiImagePlaceholder: 'Ex : un renard roux stylisé, style plat, fond transparent…',
    AiGenerate: 'Générer',
    AiGenerating: 'Génération…',
    AiPickResult: 'Choisissez une proposition',
    AiImageAdded: 'Image ajoutée au canvas',
    AiImageError: 'Échec de la génération d\'image',
    AiNoResult: 'Aucune image générée',
    AiImageNotInPlan: 'La génération d\'image IA n\'est pas incluse dans votre offre. Activez l\'option pour l\'utiliser.',
    SearchIllustration: 'Rechercher une illustration…',
    NoIllustrationFound: 'Aucune illustration trouvée',
    IllustrationIntro: 'Recherchez des illustrations vectorielles à ajouter au canvas.',
    IllustrationError: 'Échec de la recherche d\'illustrations',
    IllustrationNotVector: 'Ce résultat n\'est pas un vecteur exploitable',
    Texts: 'Textes',
    Images: 'Images',
    Colors: 'Couleurs',
    ThemeEditDesc: 'Modifiez les textes, images et couleurs du thème.',
    ThemeNotFound: 'Thème introuvable.',
    ThemeNoEditable: "Ce thème ne contient pas d'éléments modifiables.",
    Helpers: 'Règles, guides & grille',
    Rulers: 'Règles',
    RulersHint: 'Graduation en pixels',
    Guides: 'Guides',
    GuidesHint: 'Repères à 25 / 50 / 75 %',
    GridHint: 'Grille en surimpression',
    Snapping: 'Magnétisme',
    SnappingHint: 'Aligne sur centre / grille / autres objets',
    LeaveConfirm: 'Êtes-vous sûr de vouloir perdre vos modifications ?',
    Products: 'Produits',
    Customization: 'Personnalisation',
    BackToCustomizationType: 'Type de personnalisation',
    SaveNoChanges: 'Aucune modification à enregistrer',
    ChooseCategory: 'Choisissez une catégorie',
    SelectProduct: 'Choisissez un produit',
    Loading: 'Chargement',
    ProofLogoTooLarge: 'Logo trop lourd (500 Ko maximum).',
    ProofLogoInvalidType: 'Format d\'image non supporté.',
    ProofLogoImported: 'Logo importé.',
    ProofLogoImportFailed: 'Échec de l\'import du logo.',
    YouHaveProjects: 'Vous avez {count} projet(s) en cours',
    ResumeProject: 'Reprendre un projet',
    ResumeProjectHint: 'Reprenez là où vous vous êtes arrêté.',
    YourProjects: 'Vos projets en cours',
    OpenProject: 'Ouvrir ce projet',
    NoProjects: 'Aucun projet en cours.',
    AppUpdating: 'Mise à jour de l\'application…',
    DraftRestored: 'Brouillon restauré',
    SaveExpiredTitle: 'Sauvegarde expirée',
    SaveExpiredMessage: 'Cette sauvegarde a expiré ou n\'est plus disponible.',
    Continue: 'Continuer',
    PhotoFramePickShape: 'Choisissez un cadre',
    PhotoFramePlacePhoto: 'Placez et ajustez votre photo',
    PhotoFrameChangePhoto: 'Changer de photo',
    PhotoFrameDropTitle: 'Glissez une photo ici',
    PhotoFrameDropSub: 'ou cliquez pour importer',
    Rotation: 'Rotation',
    Reset: 'Réinitialiser',
    ProofLogoTitle: 'Logo du bon à tirer',
    ProofLogoUseSite: 'Garder le logo de {site}',
    ProofLogoUseMine: 'Avec mon propre logo',
    ProofLogoUseMineDesc: 'Uniquement sur le bon à tirer, pas sur les fichiers d\'impression.',
    ProofLogoNone: 'Sans aucun logo',
    ProofLogoDropTitle: 'Importez votre logo',
    ProofLogoDropHint: 'PNG, JPG, WebP, SVG',
    LoadingValidation: 'Validation de votre commande',
    LoadingStepScreenshots: 'Génération des aperçus',
    LoadingStepPrintFile: 'Génération des fichiers d\'impression',
    LoadingStepUpload: 'Envoi au serveur',
    LoadingStepSave: 'Sauvegarde de la configuration',
    LoadingGraduation: 'Chargement de la graduation',
    OptimizingImage: 'Optimisation de l\'image',
    LoadingScene: 'Chargement de la scène',
    LoadingStepZip: 'Création du zip',
    LoadingProduct: 'Chargement du produit',
    Category: 'Catégorie',
    Product: 'Produit',
    Summary: 'Sommaire',
    Zone: 'Zone',
    SelectZone: 'Sélectionner une zone',
    SelectAZone: 'Choisir une zone',
    Undo: 'Annuler',
    Redo: 'Rétablir',
    Recenter: 'Recentrer la vue',
    HelpersIntro: 'Bordures des zones, grille, règles et guides sur le canvas 2D.',
    ShowZoneBordersHint: 'Cadres des zones sur le canvas principal',
    Save: 'Enregistrer',
    Saving: 'Enregistrement',
    Grid: 'Grille',
    SwitchTo3D: 'Passer en 3D',
    PrintZone: "Zone d'impression",
    ViewModeSwitch: "Mode d'affichage",
    ViewMode3D: '3D',
    ViewMode2D: '2D',
    ViewModeUI: 'UI',
    ViewModeDual: 'Double',
    ShowZoneBorders: 'Afficher le contour des zones',
    ShowZoneBordersHelp: 'Affiche/masque le contour pointillé et le libellé des zones sur le canvas 2D.',
    ManageElements: 'Gérer les éléments',
    StartWithTheme: 'Partir d\'un thème',
    Customize: 'Personnaliser',
    FromPriceForQty: 'À partir de {price} pour {qty} u.',
    FromThemeLibrary: 'Depuis notre bibliotheque de thème',
    StartFromScratch: 'Partir de zéro',
    Or: 'ou',
    PreviousCreations: 'Créations précédentes',
    WithModel: 'Avec un modèle',
    Search: 'Rechercher',
    SubCategory: 'Sous-catégorie',
    Next: 'Suivant',
    Previous: 'Précédent',
    Validate: 'Valider',
    DownloadMyProject: 'Télécharger mon projet',
    EditThemeColors: 'Modifier les couleurs des éléments',
    AddPattern: 'Ajouter un arrière-plan',
    EditGraduation: 'Modifier la graduation',
    Pattern: 'Arrière-plan',
    PatternHint: 'Le motif est répété sur toute la zone de personnalisation. Ses couleurs sont personnalisables.',
    SearchTheme: 'Rechercher un thème (titre ou tag)',
    Theme: 'Thème',
    Graduation: 'Graduation',
    Graduation_s: 'Graduation(s)',
    ErrorOccurred: 'Une erreur est survenue.',
    ReloadPage: 'Veuillez recharger votre page.',
    LoadingCategories: 'Chargement des catégories',
    ShowAll: 'Tout voir',
    Categories: 'Catégories',
    ComingSoon: 'Bientôt',
    DropImageHere: 'Glissez-déposez une image',
    ReleaseToImport: 'Relâcher pour importer',
    OrClickToBrowse: 'ou cliquez pour parcourir',
    AcceptedFormats: 'PNG, JPG, SVG, PDF, AI',
    VectorRecommendedForMethod:
        "Cette méthode d'impression fonctionne avec des couleurs définies. Nous vous recommandons d'utiliser des fichiers vectorisés pour un rendu optimal.",
    SearchInPhotoGallery: 'Chercher dans notre galerie photos',
    QrCode: 'QR Code',
    QrCodeContent: 'Contenu (URL, texte, email…)',
    QrCodePlaceholder: 'https://exemple.com',
    QrCodeForeground: 'Couleur QR',
    QrCodeBackground: 'Fond',
    QrCodeTransparentBg: 'Fond transparent',
    QrCodeErrorLevel: 'Tolérance aux erreurs',
    QrCodeErrorL: '7% (densité basse)',
    QrCodeErrorM: '15% (standard)',
    QrCodeErrorQ: '25%',
    QrCodeErrorH: '30% (haute)',
    QrCodeEmptyPreview: 'Saisissez un contenu pour prévisualiser',
    QrCodeRequired: 'Le contenu du QR Code est obligatoire.',
    QrCodeInvalidUrl: 'Saisissez une URL QR Code valide (http:// ou https://).',
    QrCodeAdd: 'Ajouter le QR code',
    QrCodeEditOnlyColors:
        "Seules les couleurs restent modifiables après la création d'un QR code. Pour changer son contenu, supprimez-le et créez-en un nouveau.",
    ImageQualityGood: 'Bonne résolution',
    ImageQualityMedium: 'Résolution moyenne',
    ImageQualityLow: 'Faible résolution — agrandissez l\'image ou réduisez sa taille sur le canvas',
    LowQualityAlertTitle: 'Attention',
    LowQualityAlertMessage:
        "Votre création comporte des images de basse qualité, ou qui ont été trop agrandies par rapport à leur résolution d'origine. Vous devez soit corriger votre création, soit accepter le risque de pixélisation à l'impression.",
    LowQualityAlertHint: 'Seuil de basse résolution :',
    LowQualityAcceptRisk: "J'accepte le risque de pixélisation pour mes images de basse qualité",
    Preview: 'Aperçu',
    Bold: 'Gras',
    Italic: 'Italique',
    Underline: 'Souligné',
    FontSize: 'Taille',
    SelectFont: 'Choisir une police',
    UploadFont: 'Importer ma police',
    UploadFontHint: 'TTF ou OTF · 5 Mo max',
    CustomFontBadge: 'importée',
    CustomFontImported: 'Police importée.',
    CustomFontFormatError: 'Format non supporté (TTF ou OTF uniquement).',
    CustomFontTooLarge: 'Police trop lourde (5 Mo maximum).',
    CustomFontImportFailed: "Échec de l'import de la police.",
    CustomFontRemoved: 'Police supprimée.',
    RecentFonts: 'Récentes',
    Clear: 'Effacer',
    TextColor: 'Couleur du texte',
    TextOutline: 'Contour',
    AddOutline: 'Ajouter un contour',
    RemoveOutline: 'Retirer le contour',
    PickColor: 'Choisir une couleur',
    PickThemeCategory: 'Choisissez une catégorie pour explorer les thèmes',
    NoThemeInCategory: 'Aucun thème dans cette catégorie',
    ThemePreviewLabel: 'Aperçu du thème',
    PickAnotherTheme: 'Choisir un autre thème',
    Keep: 'Garder',
    LoadingThemes: 'Chargement des thèmes',
    LoadingPatterns: 'Chargement des arrière-plans',
    EditableThemeColors: 'Couleurs modifiables des éléments',
    PickAColor: 'Choisissez une couleur',
    SelectALayout: 'Sélectionnez un modèle',
    CreateLayer: 'Créer un élément',
    LastDownloads: 'Derniers téléchargements',
    Cancel: 'Annuler',
    Back: 'Précédent',
    BackToProvider: 'Retour sur {provider}',
    LayerNotFound: 'L\'élément n\'a pas été trouvé',
    ChangeImage: 'Changer l\'image',
    ChangePattern: 'Changer l\'arrière-plan',
    Resize: 'Redimensionner',
    RemoveBackground: 'Détourer',
    Processing: 'Traitement…',
    AddFilter: 'Ajouter un filtre',
    PhotoCredit: 'Photo de {author} sur {provider}',
    PhotoBy: 'Photo de',
    On: 'sur',
    LinkRedirectionWarning: 'Ce lien vous redirigera vers ce site internet',
    LoadMore: 'Charger plus',
    EditLayer: 'Editer l\'élément',
    Import: 'Importer',
    FromYourDevice: 'Depuis votre appareil',
    FromImageGallery: 'Depuis la galerie d\'images',
    NoGraduationsAvailable: 'Aucune graduation disponible',
    Confirm: 'Confirmer',
    CustomizeProduct: 'Personnalisez votre produit',
    WriteYourText: 'Écrivez votre texte ici',
    Text: 'Texte',
    Image: 'Image',
    DesignSummary: 'Récapitulatif de votre design',
    AddOptions: 'Ajouter des options',
    TermsOfSale: 'Conditions genérales de vente',
    TOSMessage:
        'Je certifie que ma création est conforme aux [Conditions genérales de vente](#) et en particulier à l\'article 8- Propriété intellectuelle',
    IValidateMyCreation: 'Je valide ma création',
    FunctionalityNotAvailable: 'Fonctionnalité non disponible',
    Lock: 'Verrouiller',
    Unlock: 'Déverouiller',
    AddLayer: 'Ajouter un élément',
    LayerSectionTemplates: 'Modèles',
    LayerSectionText: 'Texte & données',
    LayerSectionImages: 'Images',
    LayerSectionDecor: 'Décor',
    LayerSectionTools: 'Outils',
    DragLayersToReorder: 'Faites glisser les calques pour les réorganiser',
    PleaseAgreeTOS: 'Veuillez accepter les conditions générales pour valider votre création.',
    ErrorExportPrintFile: 'Une erreur s\'est produite lors de l\'export du fichier d\'impression.',
    ErrorExportProofFile: 'Une erreur s\'est produite lors de l\'export du bon à tirer.',
    ErrorAddToCart: 'Une erreur s\'est produite lors de l\'ajout au panier: ',
    Gabarit: 'Gabarit',
    FicheTechnique: 'Fiche technique',
    GeneratingPrintFile: 'Génération du fichier d\'impression...',
    GeneratingProofFile: 'Génération du bon à tirer...',
    LeaveCustomizer: 'Quitter le configurateur',
    LeaveManager: 'Quitter le gestionnaire des éléments',
    ChangeProductTitle: 'Votre création va être effacée.',
    ChangeProductConfirm: 'Changer de produit va effacer votre création définitivement, êtes-vous sûr ?',
    Duplicate: 'Dupliquer',
    LoadingTheme: 'Chargement du thème',
    LoadingPattern: 'Chargement de l\'arrière-plan',
    Expand: 'Agrandir',
    Shrink: 'Rétrécir',
    TiltLeft: 'Incliner à gauche',
    TiltRight: 'Incliner à droite',
    Rotate: 'Pivoter',
    Move: 'Déplacer',
    Reposition: 'Repositionner',
    MoveUp: 'Déplacer vers le haut',
    MoveDown: 'Déplacer vers le bas',
    MoveLeft: 'Déplacer vers la gauche',
    MoveRight: 'Déplacer vers la droite',
    NoCustomization: 'Il n\'y a pas de personnalisation sur le produit.',
    MissingCustomization: 'Personnalisation manquante',
    SelectGraduation: 'Sélectionnez une graduation',
    ProofTitle: 'Bon à tirer',
    ProofDesignTitle: 'Personnalisation 2D',
    ProofScreenshotsTitle: 'Rendus 3D',
    ProofSelectedInksTitle: 'Couleurs sélectionnées',
    Warning: 'Attention',
    SelectZoneBeforeTheme: 'Veuillez selectionner une zone avant de choisir un theme.',
    ThemeTooManyElements: 'Le thème contient trop d\'éléments. Merci d\'en choisir un autre',
    Error: 'Erreur',
    ProductNotFound: 'Produit introuvable',
    ProductNotFoundMessage: 'Produit introuvable, vous allez être redirigé vers la page d\'accueil.',
    NoCategoryAvailable: 'Aucune catégorie disponible',
    CategoryNotFound: 'Catégorie introuvable',
    CategoryNotFoundMessage: 'Catégorie introuvable, vous allez être redirigé vers la page d\'accueil.',
    Unavailable: 'Indisponible',
    // Saved Configurations
    SavedConfigurations: 'Configurations sauvegardées',
    YourSavedConfigurations: 'Vos configurations sauvegardées',
    NoSavedConfigurations: 'Aucune configuration sauvegardée pour ce produit',
    ConfigurationName: 'Nom de la configuration',
    LoginToSave: 'Connectez-vous pour retrouver vos créations dans votre compte.',
    Login: 'Se connecter',
    LoggingIn: 'Connexion…',
    ContinueWithoutAccount: 'Continuer sans compte',
    SaveEmailPlaceholder: 'Votre adresse email',
    SaveEmailHint: 'Vous recevrez un lien pour reprendre votre projet (conservé 30 jours).',
    SaveConfirmTitle: 'Projet sauvegardé',
    SaveConfirmMessage: 'Votre projet est sauvegardé. Un email contenant le lien de reprise vient de vous être envoyé.',
    Created: 'Créé',
    Expires: 'Expire',
    Load: 'Charger',
    ConfirmDeleteConfiguration: 'Êtes-vous sûr de vouloir supprimer cette configuration ?',
    Close: 'Fermer',
    Step: 'Étape',
    CustomizeProductDesc: 'Choisissez comment démarrer : création libre ou à partir d’un thème proposé ci-dessous.',
    StartFromScratchDesc: 'Un canevas vierge pour ajouter textes, images et formes, sans modèle imposé.',
    ChooseProductDesc: 'Choisissez un produit à personnaliser.',
    // Méthode d'impression
    PrintMethod: "Méthode d'impression",
    ChoosePrintMethod: 'Choisissez votre méthode',
    ChoosePrintMethodDesc:
        "Sélectionnez la méthode d'impression pour ce produit. Ce choix est définitif pour cette personnalisation.",
    Digital: 'Numérique',
    ScreenPrinting: 'Sérigraphie',
    LaserEngraving: 'Gravure laser',
    Embroidery: 'Broderie',
    DisableEmbroideryEffect: 'Désactiver l’effet broderie',
    RestrictedToPalette: 'Couleurs limitées à la palette',
    ChooseInks: 'Choisissez vos encres',
    ChooseThreads: 'Choisissez vos fils',
    AppliesToZone: 'Zone : {zone}',
    Ink: 'Encre',
    Thread: 'Fil',
    AddThread: 'Ajouter un fil',
    RemoveThread: 'Retirer un fil',
    InkOverride: 'Forcer une encre',
    ThreadOverride: 'Forcer un fil',
    SuggestInks: 'Encres suggérées',
    SuggestThreads: 'Fils suggérés',
    RecommendColorsFromImage: "Recommander des couleurs depuis l'image",
    NoColorSuggestion: 'Aucune suggestion de couleur pour cette image.',
    InkAssistantHelp: 'Cette méthode utilise une palette de {count} couleurs fixes.',
    InkAssistantQuestion: 'Comment souhaitez-vous définir vos couleurs ?',
    InkAssistantUpload: "M'aider à trouver mes couleurs",
    InkAssistantUploadDesc:
        'Importez votre image, logo ou motif — nous détectons automatiquement les couleurs de la palette les plus proches.',
    InkAssistantManual: 'Je choisis mes couleurs manuellement',
    InkAssistantManualDesc: 'Sélectionnez chaque couleur, une à une, dans la palette.',
    InkAssistantAnalyzing: 'Analyse de votre image…',
    InkChoiceModifiableHint: 'Ce choix reste modifiable à tout instant.',
    InkAssistantResultDesc: 'Voici les couleurs de la palette les plus proches de votre image.',
    InkDuplicateWarning:
        'Cette couleur est déjà sélectionnée pour une autre encre / fil. La sélectionner une seconde fois va aplatir les couleurs définitivement ! Êtes-vous sûr ?',
    Selected: 'Sélectionné',
    Add: 'Ajouter',
    VectorizeImage: "Vectoriser l'image",
    Vectorizing: 'Vectorisation en cours…',
    VectorizePreviewTitle: 'Résultat de la vectorisation',
    VectorizeIntro:
        "L'image sera convertie en vecteur et limitée aux encres choisies. Validez le rendu pour l'appliquer.",
    VectorizeApply: 'Appliquer le vecteur',
    VectorizeConsent:
        'Je comprends que je suis responsable du contrôle du résultat de la vectorisation et que l\'impression sera le reflet de celle-ci.',
    VectorizeThreshold: 'Seuil (détail / fond)',
    VectorizeThresholdHint:
        'Réglez le seuil pour affiner : plus bas, on retire davantage de fond clair (line-art) ; plus haut, on garde plus de zones claires.',
    VectorizeDenoise: 'Réduire le bruit',
    VectorizeDenoiseHint: 'Supprime les taches et petits points parasites.',
    VectorizeSmoothing: 'Lissage',
    VectorizeSmoothingHint: 'Arrondit les contours (moins d\'angles).',
    ZoomIn: 'Zoom avant',
    ZoomOut: 'Zoom arrière',
    Fit: 'Ajuster',
    // --- Clés de la refonte FO (étaient appelées sans exister → non surchargeables) ---
    Apply: 'Appliquer',
    Edit: 'Modifier',
    Support: 'Support',
    VectorizeAcknowledge:
        'Je comprends que je suis responsable du contrôle du résultat de la vectorisation et que l\'impression sera le reflet de celle-ci.',
    Crop: 'Recadrer',
    Font: 'Police',
    Style: 'Style',
    Outline: 'Contour',
    Steps: 'Étapes',
    Tools: 'Outils',
    ThemeColors: 'Couleurs',
    Minimize: 'Réduire',
    MoveLayerUp: 'Monter le calque',
    MoveLayerDown: 'Descendre le calque',
    DragLayer: 'Glisser pour réorganiser',
    NoResult: 'Aucun résultat',
    SearchElement: 'Rechercher un élément…',
    ExpertMode: 'Mode expert',
    Finish: 'Terminer',
    ChooseImageOrPhoto: 'Choisir une image ou photo',
    WizardIntro: 'Suivez les étapes, pour une création personnalisée en 1 minute.',
    WizardIntroExpert: 'Envie de plus de liberté ? Passez en mode expert.',
    ClickToChooseImage: 'Cliquez ici pour choisir une image ou photo',
    ChooseCategoryDesc: 'Sélectionnez une famille de produits pour commencer.',
    SelectProductDesc: 'Sélectionnez un produit pour commencer…',
    FinalReview: 'Dernière étape',
    StartWithThemeDesc: 'Partez d\'un design pré-configuré.',
    WithModelDesc: 'Choisissez un gabarit pré-fait.',
    ExpertModeConfirmTitle: 'Mode Expert',
    ExpertModeConfirmMsg:
        'Passer en mode expert est un choix définitif. Ce mode est légèrement plus complexe à utiliser, mais vous permet d\'ajouter et modifier les éléments sans contrainte.',
    ExpertModeHint: 'Complétez votre création sans limite, ajoutez textes et photos comme vous le souhaitez.',
    VariableData: 'Données variables',
    PhotoFrame: 'Cadre photo',
    PhotoFrameHint: 'Choisissez une forme, puis mettez une photo dedans.',
    PhotoFrameChooseShape: '1. Forme du cadre',
    PhotoFrameChangeShape: 'Changer de forme',
    PhotoFramePickPhoto: 'Choisir une photo',
    FromLibrary: 'Depuis la bibliothèque',
    VectorizeCancel: 'Annuler',
    VectorizeFailed: 'La vectorisation a échoué. Réessayez ou changez d\'image.',
    Before: 'Avant',
    After: 'Après',
    VariableText: 'Texte variable',
    VariableTextIntro:
        "Cette fonction ressemble à un publipostage, et vous permet d'obtenir votre produit imprimé 1 exemplaire unique pour chaque texte, la quantité est automatiquement calculé pour votre panier.",
    VariableTextData: 'Données (une ligne = un exemplaire)',
    VariableTextPlaceholder: 'Jean Dupont\nMarie Martin\nPaul Bernard',
    VariableTextImport: 'Importer un CSV / Excel',
    SessionImages: 'Images importées',
    Accept: 'Accepter',
    UploadConsentMessage:
        "Je confirme qu'aucun de mes fichiers ne violera les lois en vigueur, les droits d'auteur, ou les droits des tiers.",
    VariableTextNoData: 'Ajoutez au moins une ligne pour prévisualiser.',
    VdpFields: 'Champs variables',
    VdpFieldName: 'Nom du champ',
    VdpPlace: 'Placer',
    VdpPlaced: 'Placé',
    VdpAddField: 'Ajouter un champ',
    VdpAddRow: 'Ajouter une ligne',
    VdpLine: 'Ligne',
    VdpMaxRowsReached: 'Stock maximum atteint',
    VdpImportTruncated: 'Import limité au stock disponible',
    VdpEnterData: 'Saisir mes données',
    Done: 'Terminé',
    VdpFieldStyle: 'Style du champ',
    VdpFirstRowHeader: '1re ligne = en-tête (noms des champs)',
    VdpQuantity: 'Quantité : {qty}',
    VdpQuantityHint: 'La quantité est imposée par le nombre de lignes de votre texte variable.',
    VariableTextOnlyOne: 'Un seul champ Texte variable par création.',
    VariableTextEmptyFile: 'Fichier vide ou sans colonne exploitable.',
    VariableTextImportError: 'Impossible de lire ce fichier. Utilisez un CSV ou collez le texte.',
    VariableTextExcelUnavailable: 'Lecture Excel indisponible. Exportez en CSV ou collez le texte.',
    InkAuto: 'Auto',
    PreflightScreenMissingInks:
        'Encres sélectionnées : {chosen}/{required}. Choisissez toutes les encres avant de valider.',
    PreflightScreenColorCount: 'Sérigraphie : votre création est limitée à {count} encre(s).',
    PreflightMinStroke: 'Trait minimum recommandé : {mm} mm. Les traits plus fins peuvent mal imprimer.',
    PreflightMinFont: 'Taille de police minimum recommandée : {pt} pt.',
    PreflightLaserMonochrome: 'Gravure laser : le rendu final sera monochrome.',
    // --- Refonte tunnel (coque ?ui=new) ---
    More: 'Autres',
    All: 'Tous',
    AllCategories: 'Toutes les catégories',
    SearchCategory: 'Rechercher une catégorie…',
    NoProductAvailable: 'Aucun produit dans cette catégorie.',
    ChooseProductTitle: 'Choisis ton produit à personnaliser',
    PrintMethodQuestion: 'Comment imprimer ton {product} ?',
    PrintMethodIntro:
        'Chaque méthode a ses forces et contraintes — elle définit couleurs et rendus disponibles ensuite.',
    StartLabel: 'Point de départ',
    StartTitle: 'Pars d\'un thème, ou d\'une page blanche',
    StartIntro: 'Un thème = un design prêt à retoucher (le plus rapide). La page blanche = contrôle total.',
    StepProduct: 'Produit',
    StepMethod: 'Méthode',
    StepStart: 'Départ',
    StepDesign: 'Design',
    // --- Parcours simplifié + contraintes couleur ---
    ChangeTheme: 'Changer de thème',
    BackToTheme: 'Revenir au thème',
    Recent: 'Récentes',
    WhiteNotPrintable: 'Le blanc n’est pas imprimable (transparent).',
    LetterSpacing: 'Interlettrage',
    OutlineActive: 'Contour activé',
    OutlineThickness: 'Épaisseur du contour',
    AlignLeft: 'Aligner à gauche',
    AlignCenter: 'Centrer',
    AlignRight: 'Aligner à droite',
    Uppercase: 'Majuscules',
    TextFormatting: 'Mise en forme',
    FontSizeLabel: 'Taille de police',
    SelectionActions: 'Actions sur la sélection',
    DragToMove: 'Glisser pour déplacer',
    DragToResize: 'Glisser pour redimensionner',
    DragToRotate: 'Glisser pour pivoter',
    MoveUpOneLevel: 'Monter d’un niveau',
    MoveDownOneLevel: 'Descendre d’un niveau',
    BringToFront: 'Mettre au premier plan',
    Front: 'Premier plan',
    SendToBack: 'Mettre à l’arrière-plan',
    BackgroundNeverUnderPattern: 'Arrière-plan (jamais sous un motif de fond)',
    EyedropperColor: 'Pipette couleur',
    PresetColors: 'Couleurs prédéfinies',
    RecentColors: 'Couleurs récentes',
    Palette: 'Palette',
    HexValue: 'Valeur hexadécimale',
    AiResultsHint: 'Retrouvez toutes les propositions dans Image',
    Notifications: 'Notifications',
    Zoom: 'Zoom',
    GuidedCustomization: 'Personnalisation guidée',
    Actions: 'Actions',
    InkAssistantYourChoice: 'Vous avez choisi :',
    InkAssistantCorrectQuestion: 'Souhaitez-vous corriger ce choix ?',
    '': ''
};
